import { useCallback, useEffect, useState } from "react";

import axios from "../../../../api/apiClient";

import loadingSpinner from "../../../../assets/loading.gif";

import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';


import { domain, token } from "../../../Security";
import { SetAuditTrail } from "../../../Reports/AuditTrailReportEmployeeSetup";
import { EmployeeFilter } from "./EmployeeFilter";
import { CreateSearchBarWithPlaceHolder } from "../../../CommonObjects";
import { CreateTableForEmployeesBiometrics } from "../table/CreateTableForEmployeesBiometrics";
import { ConfirmationBulkForm, ConfirmationForm } from "./Confirmation";

export function BiometricsList({ isOpen,
	onClose,
	employees,
	fetchDataBasicInfo,
	user
}
) {
	var header = [
		"Employee Id",
		"Full Name",
		"",
	]
	var accessor = [
		"employeeId",
		"fullName",
		"manage"
	]

	const [currentPage, setCurrentPage] = useState(1);
	const [employeesFromBio, setEmployeesFromBio] = useState([]);
	const [selectedToAdd, setSelectedToAdd] = useState([]);
	const [dataToAdd, setDataToAdd] = useState([]);
	const [nonExistingDataFromBio, setNonExistingDataFromBio] = useState([]);
	const [loading, setLoading] = useState(false);
	const [loadingRequest, setLoadingRequest] = useState(false);
	const [addConfirmation, setAddConfirmation] = useState(false);
	const [addConfirmationBulk, setAddConfirmationBulk] = useState(false);
	const [isSelectAll, setIsSelectAll] = useState(false);
	const [isAdd, setIsAdd] = useState(false);
	const [filterData, setFilterData] = useState([]);
	const [filterDataIndex, setFilterDataIndex] = useState(0);
	const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");
	//Request Messages -start
	const [showRequestMessage, setShowRequestMessage] = useState(false);
	const [requestMessage, setRequestMessage] = useState("");
	const [isSuccess, setIsSuccess] = useState("");
	useEffect(() => {
		if (showRequestMessage) {
			const timeoutId = setTimeout(() => {
				setShowRequestMessage(false);
			}, 5000);

			return () => clearTimeout(timeoutId);
		}

	}, [showRequestMessage]);
	function GenerateMessage({ form, message, isSuccess }) {
		return (
			<>
				<div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
					{form && (
						<div className="modal toggleMessage" style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}>
							<div className='column'>
								{isSuccess ?
									<div className='request_title row' style={{ fontWeight: "bold", color: "green", alignItems: "center" }}>
										<CheckCircleIcon />
										<span >{"SUCCESS MESSAGE"}</span>
									</div>
									:
									<div className='request_title row' style={{ fontWeight: "bold", color: "#DD5746", alignItems: "center" }}>
										<ErrorIcon />
										<span>{"ERROR MESSAGE"}</span>
									</div>
								}
								<span style={{ textAlign: "center", padding: "10px 0", color: isSuccess ? "green" : "#DD5746" }}>{message}</span>
							</div>
						</div>
					)}
				</div>
			</>
		);
	}
	//Request Messages -end

	const fetchDataAccessTemplate = useCallback(async () => {
		const apiUrl = domain + "/api/AccessTemplate";

		try {
			setLoading(true);
			const response = await axios.get(apiUrl, {
				headers: {
					'Authorization': `Bearer ${token}`,
					'Content-Type': 'application/json' // You can include other headers if needed
				}
			})
			return response.data;
		} catch (error) {
			console.error('Error fetching data:', error);
			return [];
		}
	}, []);
	const fetchDataEmployeeInfoForMasterlist = useCallback(async () => {
		const apiUrl = domain + "/api/Employee/masterlist";

		try {
			const response = await axios.get(apiUrl, {
				headers: {
					'Authorization': `Bearer ${token}`,
					'Content-Type': 'application/json'
				}
			})
			return response.data;
		} catch (error) {
			console.error('Error fetching data:', error);
			return []
		}
	}, []);
	const fetchDataAccounts = useCallback(async () => {
		const apiUrl = domain + "/api/Authentication";

		try {
			setLoading(true);
			const response = await axios.get(apiUrl, {
				headers: {
					'Authorization': `Bearer ${token}`,
					'Content-Type': 'application/json' // You can include other headers if needed
				}
			})
			return response.data;
		} catch (error) {
			console.error('Error fetching data:', error);
			return []
		}
	}, []);

	const createAccount = async (employee) => {
		const accessTemplate = await fetchDataAccessTemplate();
		const employeeInfo = await fetchDataEmployeeInfoForMasterlist();
		const accounts = await fetchDataAccounts();

		const foundTemplate = accessTemplate.find(data =>
			data.description.toLowerCase() === ("Employee").toLowerCase()
		);
		const foundEmployee = employeeInfo.find(data =>
			data.employeeId.toLowerCase() === employee.employeeId.toLowerCase()
		);

		function generateUniqueUsernames(employee, existingUsernames) {
			const firstNameInitial = employee.firstName.charAt(0).toLowerCase();
			const lastNameLower = employee.lastName.replace(/\s+/g, '').toLowerCase(); // Remove spaces from last name
			let baseUsername = firstNameInitial + lastNameLower;

			let uniqueUsername = baseUsername;
			let counter = 1;

			while (existingUsernames.includes(uniqueUsername)) {
				uniqueUsername = `${baseUsername}${counter}`;
				counter += 1;
			}

			existingUsernames.push(uniqueUsername); // Add the new username to the list to avoid duplicates
			return uniqueUsername;
		}

		const apiUrl = domain + "/api/Authentication";

		const existingUsernames = [];

		accounts.forEach(employee => {
			existingUsernames.push(employee.username);
		});

		const username = generateUniqueUsernames(employee, existingUsernames);
		existingUsernames.push(username);

		const data = {
			username: username,
			password: "password",
			employeePersonalInformationId: foundEmployee.id,
			accessTemplateId: foundTemplate.id
		};

		try {
			axios.post(apiUrl + `/register`, data, {
				headers: {
					'Authorization': `Bearer ${token}`,
					'Content-Type': 'application/json'
				}
			});

		} catch (error) {
			setShowRequestMessage(true);
			setIsSuccess(false);
			console.error('Error:', error);
			const errorMessage = JSON.parse(error.response.request.responseText).message;
			setRequestMessage(errorMessage);
		}
	}
	const createAccountBulk = async (bulkData) => {
		const accessTemplate = await fetchDataAccessTemplate();
		const accounts = await fetchDataAccounts();
		const employeeInfo = await fetchDataEmployeeInfoForMasterlist();

		const foundTemplate = accessTemplate.find(data =>
			data.description.toLowerCase() === ("Employee").toLowerCase()
		);

		function generateUniqueUsernames(employee, existingUsernames) {
			const firstNameInitial = employee.firstName.charAt(0).toLowerCase();
			const lastNameLower = employee.lastName.replace(/\s+/g, '').toLowerCase(); // Remove spaces from last name
			let baseUsername = firstNameInitial + lastNameLower;

			let uniqueUsername = baseUsername;
			let counter = 1;

			while (existingUsernames.includes(uniqueUsername)) {
				uniqueUsername = `${baseUsername}${counter}`;
				counter += 1;
			}

			existingUsernames.push(uniqueUsername); // Add the new username to the list to avoid duplicates
			return uniqueUsername;
		}

		const apiUrl = domain + "/api/Authentication";

		const existingUsernames = [];
		const dataToAdd = [];

		for (const employee of bulkData) {
			const foundEmployee = employeeInfo.find(data =>
				data.employeeId.toLowerCase() === employee.employeeId.toLowerCase()
			);

			accounts.forEach(employee => {
				existingUsernames.push(employee.username);
			});

			const username = generateUniqueUsernames(employee, existingUsernames);
			existingUsernames.push(username);

			const data = {
				username: username,
				password: "password",
				employeePersonalInformationId: foundEmployee.id,
				accessTemplateId: foundTemplate.id
			};

			dataToAdd.push(data)
		}

		try {
			axios.post(apiUrl + `/register/bulk`, dataToAdd, {
				headers: {
					'Authorization': `Bearer ${token}`,
					'Content-Type': 'application/json'
				}
			});

		} catch (error) {
			setShowRequestMessage(true);
			setIsSuccess(false);
			console.error('Error:', error);
			const errorMessage = JSON.parse(error.response.request.responseText).message;
			setRequestMessage(errorMessage);
		}
	}

	const handleClose = () => {
		onClose();
		setSelectedToAdd([]);
		setIsSelectAll(false);
		setFilterDataIndex(0);
	};

	const closeConfirmationHandleClick = () => {
		setAddConfirmation(false);
	}
	const closeConfirmationBulkHandleClick = () => {
		setAddConfirmationBulk(false);
	}

	const fetchData = useCallback(async () => {
		const apiUrl = domain + "/api/Employee/biometrics-employees";
		setLoading(true);

		try {
			const response = await axios.get(apiUrl, {
				headers: {
					'Authorization': `Bearer ${token}`,
					'Content-Type': 'application/json'
				}
			})

			const nonExistingData = response.data.filter(responseEmployee =>
				!employees.some(employee => employee.employeeId.trim() === responseEmployee.employeeId.trim())
			);

			setNonExistingDataFromBio(nonExistingData);

			if (filterDataIndex === 2) { // filter existing
				const existingData = response.data.filter(responseEmployee =>
					employees.some(employee => employee.employeeId.trim() === responseEmployee.employeeId.trim())
				);

				setEmployeesFromBio(existingData);
				setFilterData(existingData);
			} else if (filterDataIndex === 3) { // filter non existing
				setEmployeesFromBio(nonExistingData);
				setFilterData(nonExistingData);
			} else {
				setEmployeesFromBio(response.data);
				setFilterData(response.data);
			}
		} catch (error) {
			console.error('Error fetching data:', error);
		} finally {
			setLoading(false);
		}
	}, [employees, filterDataIndex]);

	const handleSubmit = async (event) => {
		event.preventDefault();

		const apiUrl = domain + "/api/Employee";

		const data = {
			employeeId: dataToAdd.employeeId.trim(),
			lastName: dataToAdd.lastName,
			firstName: dataToAdd.firstName,
			fullName: dataToAdd.fullName,
			middleName: "",
			extensionName: "",
			nickName: "",
			age: null,
			dateOfBirth: null,
			placeOfBirth: "",
			civilStatus: "",
			bloodType: "",
			height: "",
			weight: "",
			citizenship: "",
			religion: "",
			gender: "",
			mobileNumber: "",
			emailAddress: "",
			province: "",
			region: "",
			blkLot: "",
			street: "",
			barangay: "",
			city: "",
			postalCode: "",
			yearsOfStay: null,
			photo: "",
			deviceNumber: "",
			employeeInformation: {
				employeePersonalInformationId: 0,
				locationId: 1,
				dateEmployed: null,
				dateRegular: null,
				dateProbationary: null,
				dateProjectBase: null,
				dateContractual: null,
				employmentDuration: null,
				employmentId: 1,
				departmentId: 1,
				sectionId: 1,
				classificationId: 2,
				payTypeId: 1,
				shiftScheduleId: 1,
				positionId: 1,
				companyId: 1,
				salaryType: "",
				createdDate: new Date(),
				createdBy: 0,
				updatedDate: null,
				updatedBy: 0
			},
			employeeStatuses: {
				// employeePersonalInformationId: employeeId,
				status: "Active",
			},
			/* employeeReportTo: {
					employeePersonalInformationId: 0,
					reportToId: null
			},
			employeeAccountInformation: {
					employeePersonalInformationId: 0,
					sss: "",
					tin: "",
					passport: "",
					philhealth: "",
					pagibig: "",
					primaryBankAccountId: null
			},
			employeeBankAccount: [
					{
					employeePersonalInformationId: 0,
					employeePersonalInformationEmployeeId: "",
					bankAccount: "",
					bankName: ""
					}
			],
			employeeSalary: {
					employeePersonalInformationId: 0,
					salary: "",
					allowance: ""
			},
			employeeRestDays: [
					{
					employeePersonalInformationId: 0,
					day: ""
					}
			],
			employeeEducationAttainments: [
					{
					employeePersonalInformationId: 0,
					level: "",
					schoolName: "",
					address: "",
					dateFrom: null,
					dateTo: null,
					course: "",
					honors: ""
					}
			],
			employeeDependents: [
					{
					employeePersonalInformationId: 0,
					lastName: "",
					firstName: "",
					middleName: "",
					extensionName: "",
					dateOfBirth: null,
					gender: "",
					civilStatus: ""
					}
			],
			employeeFamilyData: [
					{
					employeePersonalInformationId: 0,
					name: "",
					dateOfBirth: null,
					occupation: "",
					contactNumber: "",
					age: null,
					address: "",
					relationship: ""
					}
			],
			employeeEmergencyContacts: [
					{
							employeePersonalInformationId: 0,
							name: "",
							relationship: "",
							contactNumber: "",
							address: ""
					}
			] */
		};

		try {
			setLoadingRequest(true);
			await axios.post(apiUrl, data, {
				headers: {
					'Authorization': `Bearer ${token}`,
					'Content-Type': 'application/json'
				}
			});
			await SetAuditTrail({
				setupArea: "Employee List",
				actionTaken: "insert",
				field: "Create Employee/s From Biometrics",
				newValue: data.fullName,
				oldValue: "-",
				dateSaved: new Date(),
				savedById: user.id
			});

			setAddConfirmation(false);

			await fetchData();
			await createAccount(data);
			await fetchDataBasicInfo();

			setShowRequestMessage(true);
			setIsSuccess(true);
			setIsAdd(true);
		} catch (error) {
			setLoadingRequest(false);
			setShowRequestMessage(true);
			setIsSuccess(false);
			console.error('Error:', error);
			const errorMessage = JSON.parse(error.response.request.responseText).message;
			setRequestMessage(errorMessage);
		} finally {
			setLoadingRequest(false);
		}

		setAddConfirmation(false);
	};
	const handleSubmitBulk = async (event) => {
		event.preventDefault();

		setLoadingRequest(true);

		const apiUrl = domain + "/api/Employee/bulk";

		// Remove duplicates based on employeeId
		const uniqueSelectedToAdd = Array.from(new Set(selectedToAdd.map(data => data.employeeId)))
			.map(id => {
				return selectedToAdd.find(data => data.employeeId === id);
			});

		const bulkData = uniqueSelectedToAdd
			.filter(data => data.employeeId.length <= 20)  // Only include employeeId with 20 characters or fewer
			.map(data => ({
				employeeId: data.employeeId.trim(),
				lastName: data.lastName,
				firstName: data.firstName,
				fullName: data.fullName,
				employeeInformation: {
					employeePersonalInformationId: 0,
					locationId: 1,
					dateEmployed: null,
					dateRegular: null,
					dateProbationary: null,
					dateProjectBase: null,
					dateContractual: null,
					employmentDuration: null,
					employmentId: 1,
					departmentId: 1,
					sectionId: 1,
					classificationId: 2,
					payTypeId: 1,
					shiftScheduleId: 1,
					positionId: 1,
					companyId: 1,
					salaryType: "",
					createdDate: new Date(),
					createdBy: 0,
					updatedDate: null,
					updatedBy: 0
				},
				employeeStatuses: {
					status: "Active",
				},
			}));

		try {
			await axios.post(apiUrl, bulkData, {
				headers: {
					'Authorization': `Bearer ${token}`,
					'Content-Type': 'application/json'
				}
			});
			await SetAuditTrail({
				setupArea: "Employee List",
				actionTaken: "insert",
				field: "Create Employee/s From Biometrics",
				newValue: "[bulk data]",
				oldValue: "-",
				dateSaved: new Date(),
				savedById: user.id
			});
			setAddConfirmationBulk(false);

			await fetchData();
			await fetchDataBasicInfo();

			await createAccountBulk(bulkData);

			setIsSelectAll(false);
			setSelectedToAdd([]);
			setIsAdd(true);
			setShowRequestMessage(true);
			setIsSuccess(true);
		} catch (error) {
			setLoadingRequest(false);
			setShowRequestMessage(true);
			setIsSuccess(false);
			console.error('Error:', error);
			const errorMessage = JSON.parse(error.response.request.responseText).message;
			setRequestMessage(errorMessage);
		} finally {
			setLoadingRequest(false);
		}

		setAddConfirmationBulk(false);
	};
	const handleFilter = (value) => {
		const lowercaseValue = value.toLowerCase();
		setCurrentPage(1);
		var res = [];

		switch (filterDataIndex) {
			case 0:
				res = filterData.filter((f) =>
					f.fullName.toLowerCase().includes(lowercaseValue)
				);
				break;
			case 1:
				res = filterData.filter((f) =>
					f.employeeId.toString().startsWith(lowercaseValue)
				);
				break;
			case 2:
				res = filterData.filter((f) =>
					f.fullName.toLowerCase().includes(lowercaseValue)
				);
				break;
			case 3:
				res = filterData.filter((f) =>
					f.fullName.toLowerCase().includes(lowercaseValue)
				);
				break;
			default:
				res = filterData.filter((f) =>
					f.fullName.toLowerCase().includes(lowercaseValue)
				);

				break;
		}

		setEmployeesFromBio(res);
	};

	const selectAllHandler = () => {
		if (isSelectAll) {
			setIsSelectAll(false);
		} else {
			setIsSelectAll(true);
		}
	}

	useEffect(() => {
		fetchData();
		switch (filterDataIndex) {
			case 0:
				setSearchPlaceholder("Search by name")
				break;
			case 1:
				setSearchPlaceholder("Search by id")
				break;
			case 2:
				setSearchPlaceholder("Search by name")
				break;
			case 3:
				setSearchPlaceholder("Search by name")
				break;
			default:
				setSearchPlaceholder("Search by name")
				break;
		}
	}, [fetchData, filterDataIndex]);

	useEffect(() => {
		if (isSelectAll) {
			setSelectedToAdd(nonExistingDataFromBio);
		} else {
			setSelectedToAdd([]);
		}
	}, [isSelectAll, nonExistingDataFromBio]);

	return (
		<>
			<div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
				{isOpen && (
					<div className="modal">
						<div className="popUp-header row">
							<div className="popUp-title">
								<h3 style={{ color: "#668fca" }}>{"Employee's List from Biometrics"}</h3>
							</div>
							<div className="popUp-close">
								<CloseIcon onClick={() => handleClose()} />
							</div>
						</div>
						<div className="transaction-body">
							<EmployeeFilter setFilterDataIndex={setFilterDataIndex} />
							<div className="transaction-body-top row">
								{CreateSearchBarWithPlaceHolder("",
									"transaction-search row",
									"transaction-search-icon",
									"transaction-search-input",
									(e) => handleFilter(e.target.value),
									searchPlaceholder,
									SearchIcon)}

							</div>
							<div className="transaction-body-top row">
								<div style={{ margin: "0 5px" }}>
									<button className='select' onClick={selectAllHandler}>
										{isSelectAll ? "UNSELECT ALL" : "SELECT ALL"}
									</button>
								</div>
								<div style={{ margin: "0 5px" }}>
									<button className={`${selectedToAdd.length > 0 ? "add" : "add-disabled"}`}
										disabled={selectedToAdd.length > 0 ? false : true}
										onClick={() => setAddConfirmationBulk(true)}>
										ADD ALL SELECTED
									</button>
								</div>
							</div>
						</div>
						<div className="popUp-body biometrics-modal">
							<div className="select-employee-table employee-list-table">
								<CreateTableForEmployeesBiometrics
									dataList={employeesFromBio}
									dataHeader={header}
									dataAccessor={accessor}
									employees={employees}
									setDataToAdd={setDataToAdd}
									setAddConfirmation={setAddConfirmation}
									selectedToAdd={selectedToAdd}
									setSelectedToAdd={setSelectedToAdd}
									isSelectAll={isSelectAll}
									isAdd={isAdd}
									setIsAdd={setIsAdd}
									currentPage={currentPage}
									setCurrentPage={setCurrentPage}
								/>
								{employeesFromBio.length > 0 ? (
									<div></div>
								)
									:
									(
										<div>
											{loading ? (
												<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
													<img src={loadingSpinner} alt="Loading..." />
												</div>
											) : (
												<div> {/*<p>No records to display</p>*/}</div>
											)
											}
										</div>
									)}
							</div>
						</div>
					</div>
				)}
			</div>
			<ConfirmationForm isOpen={addConfirmation}
				onClose={closeConfirmationHandleClick}
				handleConfirm={handleSubmit}
			>
			</ConfirmationForm>
			<ConfirmationBulkForm isOpen={addConfirmationBulk}
				onClose={closeConfirmationBulkHandleClick}
				handleConfirm={handleSubmitBulk}
			>
			</ConfirmationBulkForm>
			<GenerateMessage form={showRequestMessage}
				message={isSuccess ? "Request Success!" : requestMessage}
				isSuccess={isSuccess}
			>
			</GenerateMessage>
			{loadingRequest ? (
				<div style={{ position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)", zIndex: "3005" }}>
					<img src={loadingSpinner} alt="Loading..." />
				</div>
			) : (
				<></>
			)
			}
		</>
	);
}